import messages from './messages'

export const DEFAULT_LOCALE = 'en-US'

export type Locales = keyof typeof messages
export const locales = Object.keys(messages) as Locales[]
